import React from 'react';
import { SketchPicker, ColorResult } from 'react-color';
import { Input } from '@components/ui/input';
import {
    Popover,
    PopoverContent,
    PopoverTrigger
} from '@components/ui/popover';
import { FieldLabel } from '../textfield';

interface ColorPickerProps {
    value: string;
    onChange: (color: string) => void;
    label?: string;
    helperText?: string;
}

const PRESET_COLORS = [
    '#4bbbbd',
    '#b44492',
    '#9c27b0',
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffc107',
    '#ff9800',
    '#ff5722',
    '#ff4500',
    '#795548',
    '#3f51b5',
    '#2196f3',
    '#607d8b'
];

export const ColorPicker: React.FC<ColorPickerProps> = ({
    value,
    onChange,
    label = 'Color',
    helperText
}) => {
    const id = React.useId();

    const handleChange = (color: ColorResult) => {
        onChange(color.hex);
    };

    return (
        <div className="flex w-full flex-col gap-1.5">
            <FieldLabel htmlFor={id} label={label} />
            <Popover>
                <PopoverTrigger asChild>
                    <div className="relative cursor-pointer">
                        <span
                            className="absolute inset-y-0 left-3 flex items-center"
                            aria-hidden
                        >
                            <span
                                className="size-6 rounded border"
                                style={{ backgroundColor: value || '#ffffff' }}
                            />
                        </span>
                        <Input
                            id={id}
                            value={value}
                            readOnly
                            className="cursor-pointer pl-12"
                        />
                    </div>
                </PopoverTrigger>
                <PopoverContent align="start" className="w-auto p-0">
                    <SketchPicker
                        color={value || '#ffffff'}
                        onChange={handleChange}
                        onChangeComplete={handleChange}
                        presetColors={PRESET_COLORS}
                    />
                </PopoverContent>
            </Popover>
            {helperText && (
                <p className="text-xs text-muted-foreground">{helperText}</p>
            )}
        </div>
    );
};

export default ColorPicker;
